const BRANDING_CACHE_KEY = 'branding_cache';

export const getCachedBranding = () => {
  try {
    const data = localStorage.getItem(BRANDING_CACHE_KEY);
    return data ? JSON.parse(data) : null;
  } catch {
    return null;
  }
};

export const setCachedBranding = branding => {
  try {
    localStorage.setItem(BRANDING_CACHE_KEY, JSON.stringify(branding));
  } catch {}
};

export const clearCachedBranding = () => {
  localStorage.removeItem(BRANDING_CACHE_KEY);
};
